import React, { useEffect, useState, useRef } from "react";
import "./Home.css";
import axios from "axios";
// Swiper modules
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay, FreeMode, Mousewheel } from 'swiper/modules';
// Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/free-mode';
import { useImage } from "../../context/ImageContext.js";
import ProductList from "../product/ProductList.js";
import { Helmet } from "react-helmet-async";
import Loader from '../../components/Loader.js';
import CampaignProducts from "../../components/campainProduct/CampaignProducts.js";
import { getApiUrl } from "../../config.js";
import StoreStoryModal from "../../components/StoreStoryModal.js";
// import EventsPopup from "../../components/EventsPopup.js";

const setCookie = (name, value, hoursTTL) => {
  const now = new Date();
  now.setTime(now.getTime() + hoursTTL * 60 * 60 * 1000);
  const expires = "expires=" + now.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
};

const getCookie = (name) => {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

const Home = () => {
  const { getImageUrl } = useImage();
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showEventsPopup, setShowEventsPopup] = useState(false);
  const [showStoreModal, setShowStoreModal] = useState(false);
  const [selectedStore, setSelectedStore] = useState(null);

  useEffect(() => {
    const timer = setTimeout(() => {
      try {
        const popupCookie = getCookie('eventsPopupShown');

        if (!popupCookie) {
          setShowEventsPopup(true);
          setCookie('eventsPopupShown', 'true', 1);
        }
      } catch (error) {
        console.error("Popup gösterme hatası:", error);
      }
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const closeEventsPopup = () => {
    setShowEventsPopup(false);
  };

  const handleStoreClick = (store) => {
    // Eğer story_image yoksa direkt mağazaya yönlendir
    if (!store.story_image) {
      window.location.href = `/${store.magaza_sef}/all`;
      return;
    }

    // Story varsa modal'ı aç
    setSelectedStore(store);
    setShowStoreModal(true);
  };

  const closeStoreModal = () => {
    setShowStoreModal(false);
    setSelectedStore(null);
  };

  useEffect(() => {

    const fetchLogos = async () => {
      try {
        const token = localStorage.getItem('token');
        const tkn = localStorage.getItem('tkn');
        const response = await axios.get(`${getApiUrl()}/stores`, {
          method: 'GET',
          headers: {
            'Authorization': `${token}`,
            'Tkn': `${tkn}`,
            'Content-Type': 'application/json',

          },

        });
        const storesWithStory = response.data.map(store => ({
          ...store,
          story_image: store.story_image || null,
          story_url: store.story_url || null,
          stories: store.stories || (store.story_image ? [{
            story_image: store.story_image,
            story_url: store.story_url,
            created_at: store.story_created_at || new Date().toISOString()
          }] : [])
        }));
        setStores(storesWithStory);

      } catch (error) {
        console.error("API'den veriler çekilirken hata oluştu:", error);
      }
    };

    fetchLogos();
  }, []);


  useEffect(() => {
    if (stores.length > 0) {
      stores.forEach((store) => {
        const link = document.createElement("link");
        link.rel = "preload";
        link.as = "image";
        link.href = store.image;
        document.head.appendChild(link);
      });
    }
  }, [stores]);


  // Modern Swiper ayarları
  const swiperBreakpoints = {
    250: {
      slidesPerView: 3,
      spaceBetween: 5,
    },
    320: {
      slidesPerView: 4,
      spaceBetween: 5,
    },
    480: {
      slidesPerView: 4,
      spaceBetween: 5,
    },
    768: {
      slidesPerView: 5,
      spaceBetween: 5,
    },
    1024: {
      slidesPerView: 8,
      spaceBetween: 20,
    },
    1600: {
      slidesPerView: 11,
      spaceBetween: 25,
    },
  };


  if (loading) return <Loader />;
  return (
    <>
      {/* {showEventsPopup && <EventsPopup onClose={closeEventsPopup} />} */}

      <div>
        <Helmet>
          <title>BiKuyum - İkinci El Altınlar</title>
          <meta name="description" content="BiKuyum - İkinci el altın alımında güvenli bir deneyim sunan, kuyumcu destekli bir dijital platformdur." />
          <meta name="keywords" content="ikinci el altın, altın alım, kuyumcu, altın, mücevher, BiKuyum, kuyum" />
          <meta property="og:title" content="BiKuyum - İkinci El Altınlar" />
          <meta property="og:description" content="BiKuyum - İkinci el altın alımında güvenli bir deneyim sunan, kuyumcu destekli bir dijital platformdur." />
          <meta property="og:url" content="https://bikuyum.com" />
          <link rel="canonical" href="https://bikuyum.com" />
        </Helmet>

      </div>

      <div className="store-slider-container">
        {stores.length > 0 && (
          <Swiper
            modules={[Navigation, Pagination, Autoplay, FreeMode, Mousewheel]}
            spaceBetween={20}
            slidesPerView={10}
            loop={true}
            autoplay={{
              delay: 2000,
              disableOnInteraction: false,
              pauseOnMouseEnter: true,
            }}
            freeMode={{
              enabled: true,
              sticky: false,
              momentum: true,
              momentumRatio: 0.25,
              momentumVelocityRatio: 0.25,
            }}
            mousewheel={{
              forceToAxis: true,
              sensitivity: 0.5,
            }}
            grabCursor={true}
            touchRatio={1.5}
            touchAngle={45}
            simulateTouch={true}
            allowTouchMove={true}
            resistanceRatio={0.85}
            threshold={5}
            longSwipesRatio={0.5}
            longSwipesMs={300}
            followFinger={true}
            shortSwipes={true}
            longSwipes={true}
            breakpoints={swiperBreakpoints}
            className="stores-swiper py-4"
          >
            {stores.map((store) => (
              <SwiperSlide key={store.kullanici_id}>
                <div
                  className="store-logo-link text-decoration-none"
                  onClick={() => handleStoreClick(store)}
                  style={{ cursor: 'grab' }}
                >
                  <div className="store-logo-item d-flex overflow-hidden rounded-circle">
                    <img
                      src={getImageUrl(store.image)}
                      alt={store.magaza_adi}
                      className="store-logo rounded-circle"
                      loading="lazy"
                      onError={(e) => {
                        e.target.src = '/logo.webp';
                      }}
                    />
                  </div>
                  <div>
                    <p className="storep mt-2 text-center fw-bold">{store.magaza_adi}</p>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>

      <div>
        <CampaignProducts />
      </div>

      <div>
        <ProductList />
      </div>

      {/* Store Story Modal */}
      <StoreStoryModal
        isOpen={showStoreModal}
        onClose={closeStoreModal}
        store={selectedStore}
        stories={selectedStore?.stories || []} // Bu mağazanın story'leri
      />

    </>
  );

}
export default Home;

